define('analytics-popover/analytics-popover',['require','exports','module','api-access','text!./analytics-popover-template.html'],function (require, exports, module) {
    var userApi = require('api-access').user;

    function AnalyticsPopover() {
        var self = this;

        var setSalePopupShown = function () {
            userApi.updateSettings({setSaleAnalyticsPopoverShown: true});
        };

        var isSetSaleEnabled = function (userSettings) {
            var isSetSaleProvisioned = userSettings.setSaleProvisioned && userSettings.setSaleEntitled;
            var isSetSaleEnabledFlag = userSettings.setSaleEnabled;
            return isSetSaleProvisioned && isSetSaleEnabledFlag;
        };

        var mouseUpHandler = function (event) {
            var popOver = $('#menu-analytics + .popover');

            if (!popOver.is(event.target) &&
                popOver.has(event.target).length === 0) {
                self.hide();
            }
        };

        self.hide = function () {
            $('#menu-analytics').popover('hide');
        };

        self.show = function () {
            userApi.settings().then(function (userSettings) {
                /*
                 * SetSale popover is to be shown to the user if
                 * 1. It is third login
                 * 2. setSale is provisioned but not enabled
                 * 3. The tab is shown previously and the popover is not shown
                 */

                var analyticsTab = $('#menu-analytics');
                var isEnabled = isSetSaleEnabled(userSettings);
                var showSetSalePopover = userSettings.setSaleAnalyticsTabShown && !isEnabled;

                if (!userSettings.setSaleAnalyticsPopoverShown && showSetSalePopover) {
                    analyticsTab.popover({
                        trigger: 'manual',
                        placement: 'bottom',
                        html: true,
                        template: require('text!./analytics-popover-template.html'),
                        content: function () {
                            return $('#analytics-popover-content').html();
                        }
                    });

                    analyticsTab.on('shown.bs.popover', function () {
                        $(document).bind('mouseup', mouseUpHandler);
                    });

                    analyticsTab.on('hidden.bs.popover', function () {
                        $(document).unbind('mouseup', mouseUpHandler);
                    });

                    analyticsTab.popover('show');

                    // setting update for user that pop over has been shown
                    setSalePopupShown();

                    $('#analytics-popover-close-btn').click(function () {
                        self.hide();
                    });
                }
            });
        };
    }

    module.exports = new AnalyticsPopover();
});

